/**
 * @file:  商品 属性列表
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/02/28      1.0     First version
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */
import React  from "react";
import PropTypes from "prop-types";
import { Popover,} from 'antd';
import { toFixedWithCommas} from "@utils/number-util";
import "./index.less";

export default class Attributes extends React.Component {
    static propTypes = {
        sku: PropTypes.object,
    };
    static defaultProps = {
        sku: {}, // 公司资料完善标记
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            openEd: false,
            list:[]
        }
        this.__getServerLanguage = __getServerLanguage;
        ;
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 请求
     * */
    postHttpAction(sUrl,data,callback){
        return $.ajax({
            url: sUrl,
            type:'post',
            dataType: "json",
            contentType: 'application/json',
            data:JSON.stringify(data),
            success:(res)=>{
                callback(res)
            }
        });
    }
    /**
    * 获取更多 属性
    * @param flag 第一次打开
    * */
    showAttrMore(flag=false){
        if(this.props.sku&&flag){
            const sUrl = "/data/mc/r/shopping-cart/get-other-attribute";
            const postData = {
                skuId:this.props.sku.skuId
            }
            this.postHttpAction(sUrl, postData, (resData) => {
                this.loading(false);
                const { models, success, valid,  } = resData;
                if (success &&valid) {
                    this.setState({
                        list: models || [],
                        openEd: true
                    })
                }
            });
        }
    }
    render() {
        const { openEd,list } =this.state;
        const { sku } =this.props;
        return (<div className={"attrList"}>
            {/* 货期 */}
            <div className={"font-12"}>
                <span className={"black89"}>{this.__getServerLanguage("HuoQi")}</span>
                <span className={`black45 ml_8${sku.deliveryDayException==1?" deleteText":""}`}>{sku.deliverDay||'-'} {this.__getServerLanguage("TianS")}</span>
                {sku.deliveryDayException==1&&<span className={"black45 ml_6"}>{sku.inqAfterDeliveryDay||'-'} {this.__getServerLanguage("TianS")}</span>}
            </div>
            {/* 装量 */}
            <div className={"font-12"}>
                <span className={"black89"}>{this.__getServerLanguage("ZhuangLiang")}</span>
                <span className={"black45 ml_8"}>{sku.skuCapacity||'-'} {sku.packageTypeName}</span>
                {sku.oldSkuCapacity?<span className={"black45 ml_8 delete"}>{sku.oldSkuCapacity||'-'} {sku.packageTypeName}</span>:null}
            </div>
            {/* 包装类型 */}
            <div className={"font-12"}>
                <span className={"black89"}>{this.__getServerLanguage("BaoZhuangLeiXing")}</span>
                <span className={"black45 ml_8"}>{sku.packageTypeName}</span>
                {sku.isPackageDepart==1&&<span className={"black45 ml_6"}>{this.__getServerLanguage("FenZhuang")}</span>}
                {sku.isPackageDepart==0&&<span className={"black45 ml_6"}>{this.__getServerLanguage("ZhengZhuang")}</span>}
            </div>
            {/* 商品编号 */}
            <div className={"font-12"}>
                <span className={"black89"}>{this.__getServerLanguage("ShangPinBianHao")}</span>
                <span className={"black45 ml_8"}>{sku.skuNo}</span>
                {sku.skuHsNo&&<span className={"black45 ml_6"}>{sku.skuHsNo}</span>}
            </div>
            {/* 更多 */}
            <Popover placement="right"
                     trigger={"click"}
                     content={<div className={"popAttrTips flex-item"}>
                         {/* 外箱体积 */}
                         <div className={"width50 font-12"}>
                             <span className={"black89"}>{this.__getServerLanguage("WaiXiangTiJi")}(m³)</span>
                             <span className={"black45 ml_8"}>
                                 {toFixedWithCommas(sku.skuOutBoxVolume, 3) || '-'}
                             </span>
                         </div>
                         {/* 毛净重 */}
                         <div className={"width50 font-12"}>
                             <span className={"black89"}>{this.__getServerLanguage("MaoJingZhong")}(Kg)</span>
                             <span className={"black45 ml_8"}>
                                 {sku.skuGrossWeight ? toFixedWithCommas(sku.skuGrossWeight, 3) : '-'}/{sku.skuNetWeight||"-"}</span>
                         </div>
                         {/* 工厂货号 */}
                         <div className={"width50 font-12 mt_8"}>
                             <span className={"black89"}>{this.__getServerLanguage("GongChangHuoHao")}</span>
                             <span className={"black45 ml_8"}>{sku.factoryNo||"-"}</span>
                         </div>
                         {/* 请求回来的数据 */}
                         {list.map(item=> <div className={"width50 font-12 mt_8"}>
                             <span className={"black89"}>{item.attribute}</span>
                             <span className={"black45 ml_8"}>{item.option||"-"}</span>
                         </div>)}
                     </div>} >
                <span className={"font-12 colorBlue cursor-p"} onClick={()=>this.showAttrMore(!openEd)}>{this.__getServerLanguage("GengDuo")}</span>
            </Popover>
        </div>);
    }
}
